import script from "./ERiskMapCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ERiskMapCard.vue?vue&type=script&setup=true&lang=ts"

import "./ERiskMapCard.vue?vue&type=style&index=0&id=2d638882&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d638882"]])

export default __exports__